export default __webpack_public_path__ + "static/img/new_space_mountains_4k.86c7bfb.jpg";